<div class="preview-mobile-panel" [class.theme-view]="section === 'THEME'">
  <div class="mobile-mockup" [class.theme-view]="section === 'THEME'">
    <div class="mobile-frame" [class.theme-view]="section === 'THEME'">
      <div class="mobile-notch" [class.theme-view]="section === 'THEME'"></div>
      <div class="mobile-screen" [class.theme-view]="section === 'THEME'">
       
        <div class="mobile-questions-screen">
          @if (previewScreen === 'welcome') {
            <app-welcome-screen-preview
              [context]="getPreviewContext()"
              [viewMode]="viewMode"
              (startClick)="startQuestionnairePreview()"
            />
          } @else if (previewScreen === 'pageLayout') {
            <div class="preview-section-anchor" #bodySectionRef>
              <app-header-section-preview
                [context]="getPreviewContext()"
                [viewMode]="viewMode"
              />
            </div>
            <div class="preview-page-body-margin" [class.mobile-view]="viewMode === 'mobile'" >
              <div class="preview-section-anchor">
                @if (currentPage > 0) {
                  <app-page-section-preview
                    [context]="getPreviewContext()"
                    [viewMode]="viewMode"
                  />
                }
              </div>
              <div class="preview-section-anchor">
                <app-body-content-preview
                  [context]="getPreviewContext()"
                  [viewMode]="viewMode"
                  (addQuestionClick)="onAddQuestion()"
                  (previousPage)="goToPreviousPage()"
                  (nextPage)="goToNextPage()"
                  (goToPage)="goToPage($event)"
                />
              </div>
            </div>
            <div class="preview-section-anchor">
              <app-footer-section-preview
                [context]="getPreviewContext()"
                [viewMode]="viewMode"
              />
            </div>
          } @else if (previewScreen === 'exit') {
            <app-exit-screen-preview
              [context]="getPreviewContext()"
              [viewMode]="viewMode"
              [questionnaire]="questionnaire"
            />
          }
        </div>
      </div>
    </div>
  </div>
</div>
